import { Controller } from "stimulus"
import { FetchRequest } from "@rails/request.js"


export default class extends Controller {
  static targets = ['submitBtn', 'dayInput', 'fromTimeInput', 'toTimeInput', 'timeConfictBanner', 'playlistInput', 'layoutInput', 'selectAllDaysButton', 'timeslotDetails', 'timeslotBox', 'priceInfo', 'loopDurationInput', 'priceInput', "scheduleDurationHoursInput", "scheduleDurationMinutesInput", "totalPriceInput"]
  static values = { scheduleId: Number, profileId: String, timeslotId: Number, timeslotAdDuration: Number}

  connect() {
    if (this.timeslotDetailsTargets.length > 0) {
      const firstTimeslotDetail = this.timeslotDetailsTargets[0];
      firstTimeslotDetail.classList.remove('hidden');
      const timeslotActiveId = firstTimeslotDetail.dataset.timeslotId;
      const timeslotActive = this.timeslotBoxTargets.filter(timeslot => timeslot.dataset.timeslotId === timeslotActiveId);
      timeslotActive.forEach(timeslot => {
        timeslot.querySelector('.timeslot-content').style.opacity = '1';
      })
    }
    if (this.hasFromTimeInputTarget && this.hasToTimeInputTarget && this.hasLoopDurationInputTarget && this.hasPriceInputTarget) {
      this.updatePriceInfo()
    }
  }

  updatePriceInfo() {
    const fromTime = this.fromTimeInputTarget.value;
    const toTime = this.toTimeInputTarget.value;
    const loopDuration = this.loopDurationInputTarget.value;
    const price = this.priceInputTarget.value;
    const adDuration = this.timeslotAdDurationValue; // fixed value as per the template
    
    const timeDiff = this.calculateTimeDifference(fromTime, toTime);
    const repeatedLoop = timeDiff.totalSeconds / loopDuration; 
    const totalPrice = (price * repeatedLoop * adDuration).toFixed(2);
    
    this.scheduleDurationHoursInputTarget.textContent = timeDiff.hours;
    this.scheduleDurationMinutesInputTarget.textContent = timeDiff.minutes;
    this.totalPriceInputTarget.textContent = totalPrice;
  }

  calculateTimeDifference(fromTime, toTime) {
    // Parse the times into minutes since midnight
    toTime = (toTime == '00:00') ? '24:00' : toTime;
    const [fromHours, fromMinutes] = fromTime.split(':').map(Number)
    const [toHours, toMinutes] = toTime.split(':').map(Number)
    
    const fromTotalMinutes = fromHours * 60 + fromMinutes
    const toTotalMinutes = toHours * 60 + toMinutes
    
    const diffMinutes = Math.abs(toTotalMinutes - fromTotalMinutes)
    
    const diffHours = Math.floor(diffMinutes / 60)
    const remainingMinutes = diffMinutes % 60
    return {
      hours: diffHours,
      minutes: remainingMinutes,
      totalSeconds: diffHours * 3600 + remainingMinutes * 60
    }
  }

  async checkTimeConflict() {
    const schedule_id = this.scheduleIdValue;
    const profile_cached_slug = this.profileIdValue;
    const url = `/profiles/${profile_cached_slug}/schedules/${schedule_id}/timeslot_conflicts`
    const days = []
    const from =  this.fromTimeInputTarget.value
    const to =  this.toTimeInputTarget.value

    this.dayInputTargets.forEach(target => {
      if(target.checked) {
        days.push(target.value)
      }
    });

    if (days.length != 7 ) {
      this.enableSelectAllButton();
    }

    if (days.length == 0 || (from == null || from == "") || (to == null || to == "")) {
      this.disableButton(false)
    } else {
      const request = new FetchRequest("post", url, {
        body: JSON.stringify(
          {
            days: days,
            from: from,
            to: to,
            timeslot_id: this.timeslotIdValue
          }
        ),
        responseKind: "json"
      });


      const response = await request.perform();

      if (response.ok) {
        const body = await response.text;
        const json = JSON.parse(body);

        if(json.error) {
          this.disableButton(true);
        } else {
          this.enableButton();
        }
      }
    }
  }

  uncheckPlaylists() {
    this.playlistInputTargets.forEach((el) => {
      el.value = '';
    });
  }

  uncheckLayouts() {
    this.layoutInputTargets.forEach((el) => {
      el.checked = false;
    });
  }

  disableButton(conflict) {
    this.submitBtnTarget.disabled = true;
    this.submitBtnTarget.classList.add('disabled');
    this.submitBtnTarget.style.opacity = "0.7";
    if(conflict) {
      this.timeConfictBannerTarget.classList.remove('hidden');
    }
  }

  enableButton() {
    this.submitBtnTarget.disabled = false;
    this.submitBtnTarget.classList.remove('disabled');
    this.submitBtnTarget.style.opacity = "1";
    this.timeConfictBannerTarget.classList.add('hidden');
  }

  selectAllDayTime() {
    this.fromTimeInputTarget.value = '00:00'
    this.toTimeInputTarget.value = '00:00'
  }

  selectAllDays() {
    this.dayInputTargets.forEach(target => {
      target.checked = true;
    });
    this.selectAllDaysButtonTarget.disabled = true;
    this.selectAllDaysButtonTarget.classList.add('opacity-60', 'cursor-not-allowed');
    this.checkTimeConflict();
  }

  enableSelectAllButton() {
    this.selectAllDaysButtonTarget.disabled = false;
    this.selectAllDaysButtonTarget.classList.remove('opacity-60', 'cursor-not-allowed');
  }

  mouseOver(event) {
    var timeslots = document.querySelectorAll("[data-schedules-id-param='" + event.target.dataset.schedulesIdParam + "']");
    let classes = ['hover', 'z-10'];
    
    if (timeslots[0] && timeslots[0].offsetWidth <= 130) {
      classes.push('popover-animation');
    }
    
    timeslots.forEach((el) => {
      el.classList.add(...classes);
    });
  }

  mouseOut(event) {
    var timeslots = document.querySelectorAll("[data-schedules-id-param='" + event.target.dataset.schedulesIdParam + "']");
    timeslots.forEach((el) => {
      el.classList.remove('hover', 'z-10');
    });
  }
  selectTimeslot(event) {
    const timeslotId = event.currentTarget.dataset.timeslotId;
    this.timeslotDetailsTargets.forEach(target => {
      target.classList.add('hidden');
    });
    this.timeslotBoxTargets.forEach(timeslot => {
      timeslot.querySelector('.timeslot-content').style.opacity = '0.5';
    })
    // Then show only the selected one
    const currentTimeslot = this.timeslotDetailsTargets.find(target => target.dataset.timeslotId === timeslotId);
    currentTimeslot.classList.remove('hidden');
    document.querySelectorAll(`[data-schedules-id-param="${timeslotId}"]`).forEach(timeslot => {
      timeslot.querySelector('.timeslot-content').style.opacity = '1';
    })
  }
}